module.exports = __webpack_public_path__ + "media/images/pc/specials/common/plan_waso-3c5a5f995653f509341bea5f0a7328d2.jpg";